export default "<hr [ngClass]=\"'ion-color-' + color\">";